import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * Note: 路由配置项
 *
 * hidden: true                     // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true                 // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                  // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                  // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                  // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect             // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'               // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * query: '{"id": 1, "name": "ry"}' // 访问路由的默认传递参数
 * roles: ['admin', 'common']       // 访问路由的角色权限
 * permissions: ['a:a:a', 'b:b:b']  // 访问路由的菜单权限
 * meta : {
    noCache: true                   // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'                  // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'                // 设置该路由的图标，对应路径src/assets/icons/svg
    breadcrumb: false               // 如果设置为false，则不会在breadcrumb面包屑中显示
    activeMenu: '/system/user'      // 当路由设置了该属性，则会高亮相对应的侧边栏。
  }
 */

// 公共路由
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/Login'),
    hidden: true
  },
  {
    path: '/register',
    component: () => import('@/views/UserRegist'),
    hidden: true
  },
  {
    path: '/gen',
    component: () => import('@/views/tool/gen'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error/401'),
    hidden: true
  }, {
    path: '/manage',
    component: () => import('../views/Manage.vue'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: 'index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/Home'),
        // component: () => import('@/views/Home'),
        name: 'Home',
        meta: { title: '应用首页公告栏', icon: 'el-icon-menu', affix: true }
      },
      {
        path: '/products/edit',
        component: () => import('@/views/Product/Createproduct'),
        name: 'editProduct',
        meta: { title: '编辑产品' },
        hidden: true
      },
      {
        path: '/products/copy',
        component: () => import('@/views/Product/Createproduct'),
        name: 'copyProduct',
        meta: { title: '复制产品' },
        hidden: true
      },
      {
        path: '/inbound/edit',
        component: () => import('@/views/DropshippingManagement/Createaninboundorder'),
        name: 'editInbound',
        meta: { title: '编辑入库单' },
        hidden: true
      },
      {
        path: '/inbound/copy',
        component: () => import('@/views/DropshippingManagement/Createaninboundorder'),
        name: 'copyInbound',
        meta: { title: '复制入库单' },
        hidden: true
      },
      {
        path: '/order/copy',
        component: () => import('@/views/Product/Agentdistribution.vue'),
        name: 'copyOrder',
        meta: { title: '复制订单' },
        hidden: true
      },
      {
        path: '/order/edit',
        component: () => import('@/views/Product/Agentdistribution.vue'),
        name: 'editOrder',
        meta: { title: '编辑订单' },
        hidden: true
      },
      {
        path: '/returns/edit',
        component: () => import('@/views/Returnsmanagement/Createreturn.vue'),
        name: 'editReturn',
        meta: { title: '编辑退件单' },
        hidden: true
      },
      {
        path: '/returns/view',
        component: () => import('@/views/Returnsmanagement/Createreturn.vue'),
        name: 'viewReturn',
        meta: { title: '查看退件单' },
        hidden: true
      },
      {
        hidden: true,
        path: '/oms/recharge',
        name: 'OmsRecharge',
        component: () => import('@/views/OmsRecharge.vue'),
        meta: { title: '账户充值', icon: 'money' }
      },
    ]
  },
  {
    path: '/user',
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: 'profile',
        component: () => import('@/views/System/user/profile/index'),
        name: 'Profile',
        meta: { title: '个人中心', icon: 'user' }
      }
    ]
  }
]

// 动态路由，基于用户权限动态去加载
export const dynamicRoutes = [
  // {
  //   path: '/system/user-auth',
  //   component: Layout,
  //   hidden: true,
  //   permissions: ['system:user:edit'],
  //   children: [
  //     {
  //       path: 'role/:userId(\\d+)',
  //       component: () => import('@/views/system/user/authRole'),
  //       name: 'AuthRole',
  //       meta: { title: '分配角色', activeMenu: '/system/user' }
  //     }
  //   ]
  // },
  // {
  //   path: '/system/role-auth',
  //   component: Layout,
  //   hidden: true,
  //   permissions: ['system:role:edit'],
  //   children: [
  //     {
  //       path: 'user/:roleId(\\d+)',
  //       component: () => import('@/views/system/role/authUser'),
  //       name: 'AuthUser',
  //       meta: { title: '分配用户', activeMenu: '/system/role' }
  //     }
  //   ]
  // },
  // {
  //   path: '/system/dict-data',
  //   component: Layout,
  //   hidden: true,
  //   permissions: ['system:dict:list'],
  //   children: [
  //     {
  //       path: 'index/:dictId(\\d+)',
  //       component: () => import('@/views/system/dict/data'),
  //       name: 'Data',
  //       meta: { title: '字典数据', activeMenu: '/system/dict' }
  //     }
  //   ]
  // },
  // {
  //   path: '/monitor/job-log',
  //   component: Layout,
  //   hidden: true,
  //   permissions: ['monitor:job:list'],
  //   children: [
  //     {
  //       path: 'index/:jobId(\\d+)',
  //       component: () => import('@/views/monitor/job/log'),
  //       name: 'JobLog',
  //       meta: { title: '调度日志', activeMenu: '/monitor/job' }
  //     }
  //   ]
  // },
  // {
  //   path: '/tool/gen-edit',
  //   component: Layout,
  //   hidden: true,
  //   permissions: ['tool:gen:edit'],
  //   children: [
  //     {
  //       path: 'index/:tableId(\\d+)',
  //       component: () => import('@/views/tool/gen/editTable'),
  //       name: 'GenEdit',
  //       meta: { title: '修改生成配置', activeMenu: '/tool/gen' }
  //     }
  //   ]
  // }
]

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push
let routerReplace = Router.prototype.replace
// push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})


//  以下是原来的
// import Vue from 'vue'
// import VueRouter from 'vue-router'
// import store from "@/store";
//
// Vue.use(VueRouter)
//
// // 检查用户是否登录
// function isLoggedIn() {
//   const user = localStorage.getItem("user");
//   return user && JSON.parse(user).token;
// }
//
// const routes = [
//   {
//     path: '/',
//     name: 'Manage',
//     component: () => import('../views/Manage.vue'),
//     redirect: "/home",
//     meta: { requiresAuth: true },
//     children: [
//       { path: 'home', name: '首页', component: () => import('../views/Home.vue'), meta: { requiresAuth: true } },
//       { path: 'user', name: '用户管理', component: () => import('../views/User.vue'), meta: { requiresAuth: true } },
//       { path: 'TransitProducts', name: '中转产品', component: () => import('../views/TransitManagement/TransitProducts.vue'), meta: { requiresAuth: true } },
//       { path: 'UserApi', name: '用户中心', component: () => import('../views/UserApi.vue'), meta: { requiresAuth: true } },
//       { path: 'ProductManagement', name: '产品管理', component: () => import('../views/Product/ProductManagement.vue'), meta: { requiresAuth: true } },
//       { path: 'Agentdistribution', name: '一件代发', component: () => import('../views/Product/Agentdistribution.vue'), meta: { requiresAuth: true } },
//       { path: 'Createproduct', name: '创建产品', component: () => import('../views/Product/Createproduct.vue'), meta: { requiresAuth: true } },
//       { path: 'BulkUploads', name: '产品分发', component: () => import('../views/Product/BulkUploads.vue'), meta: { requiresAuth: true } },
//       { path: 'transitorder', name: '中转订单', component: () => import('../views/TransitManagement/transitorder.vue'), meta: { requiresAuth: true } },
//       { path: 'Archivedorders', name: '归档订单', component: () => import('../views/TransitManagement/Archivedorders.vue'), meta: { requiresAuth: true } },
//       { path: 'Createaninboundorder', name: '创建入库单', component: () => import('../views/DropshippingManagement/Createaninboundorder.vue'), meta: { requiresAuth: true } },
//       { path: 'Inboundlistmanagement', name: '入库单管理', component: () => import('../views/DropshippingManagement/Inboundlistmanagement.vue'), meta: { requiresAuth: true } },
//       { path: 'kucunguanli', name: '库存管理', component: () => import('../views/DropshippingManagement/kucunguanli.vue'), meta: { requiresAuth: true } },
//       { path: 'piciruzhi', name: '批次日志', component: () => import('../views/DropshippingManagement/piciruzhi.vue'), meta: { requiresAuth: true } },
//       { path: 'picikuncun', name: '批次库存', component: () => import('../views/DropshippingManagement/picikuncun.vue'), meta: { requiresAuth: true } },
//       { path: 'Orderprocessing', name: '订单处理', component: () => import('../views/Order/Orderprocessing.vue'), meta: { requiresAuth: true } },
//       { path: 'Importorders', name: '批量导入订单', component: () => import('../views/Order/Importorders.vue'), meta: { requiresAuth: true } },
//       { path: 'Invoicemanagement', name: '发票管理', component: () => import('../views/Order/Invoicemanagement.vue'), meta: { requiresAuth: true } },
//       { path: 'Createreturn', name: '创建退件', component: () => import('../views/Returnsmanagement/Createreturn.vue'), meta: { requiresAuth: true } },
//       { path: 'Returnlistmanagement', name: '退货单管理', component: () => import('../views/Returnsmanagement/ReturnListManagement.vue'), meta: { requiresAuth: true } },
//       { path: 'ImportReturns', name: '批量导入订单', component: () => import('../views/Returnsmanagement/ImportReturns.vue'), meta: { requiresAuth: true } },
//       { path: 'ReturnClaim', name: '退货认领', component: () => import('../views/Returnsmanagement/ReturnClaim.vue'), meta: { requiresAuth: true } },
//       { path: 'DisposeDefectiveProducts', name: '处理不良品', component: () => import('../views/Returnsmanagement/DisposeDefectiveProducts.vue'), meta: { requiresAuth: true } },
//       { path: 'ViewProcessingResults', name: '查看处理结果', component: () => import('../views/Returnsmanagement/ViewProcessingResults.vue'), meta: { requiresAuth: true } },
//       { path: 'PlatformAccountManagement', name: '平台账号管理', component: () => import('../views/PlatformManagement/PlatformAccountManagement.vue'), meta: { requiresAuth: true } },
//       { path: 'PlatformOrderManagement', name: '平台订单管理', component: () => import('../views/PlatformManagement/PlatformOrderManagement.vue'), meta: { requiresAuth: true } },
//       { path: 'SKU', name: 'SKU关系映射', component: () => import('../views/PlatformManagement/SKU.vue'), meta: { requiresAuth: true }},
//       { path: 'ExpenseBill', name: '费用账单', component: () => import('../views/ExpenseManagement/ExpenseBill.vue'), meta: { requiresAuth: true }},
//       { path: 'CostTrial', name: '费用试算', component: () => import('../views/ExpenseManagement/CostTrial.vue'), meta: { requiresAuth: true }},
//       { path: 'OrderFees', name: '订单费用', component: () => import('../views/ExpenseManagement/OrderFees.vue'), meta: { requiresAuth: true }},
//       { path: 'ViewExpense', name:'查看费用流水', component: () => import('../views/ExpenseManagement/ViewExpense.vue'), meta: { requiresAuth: true }},
//       { path: 'WarehouseRent', name: '仓租', component: () => import('../views/ExpenseManagement/WarehouseRent.vue'), meta: { requiresAuth: true }},
//       { path: 'RemittanceNotification', name: '汇款通知', component: () => import('../views/ExpenseManagement/RemittanceNotification.vue'), meta: { requiresAuth: true }},
//       { path: 'RemittanceNotificationManagement', name: '汇款通知管理', component: () => import('../views/ExpenseManagement/RemittanceNotificationManagement.vue'), meta: { requiresAuth: true }},
//       { path: 'CardInformation', name: '银行卡信息', component: () => import('../views/ExpenseManagement/CardInformation.vue'), meta: { requiresAuth: true }},
//       { path: 'ExportDownloads', name: '异步导出下载', component: () => import('../views/System/ExportDownloads.vue'), meta: { requiresAuth: true }},
//       { path: 'UserCenter', name: '用户中心', component: () => import('../views/System/UserCenter.vue'), meta: { requiresAuth: true }},
//       { path: 'PrinterSettings', name: '打印机设置', component: () => import('../views/System/PrinterSettings.vue'), meta: { requiresAuth: true }},
//       { path: 'Help', name: '帮助', component: () => import('../views/System/Help.vue'), meta: { requiresAuth: true }},
//       { path: 'HelpCenter', name: '帮助中心', component: () => import('../views/System/HelpCenter.vue'), meta: { requiresAuth: true }},
//       { path: 'ToDos', name: '代办事项', component: () => import('../views/System/ToDos.vue'), meta: { requiresAuth: true }},
//       { path: 'FeedbackProblem', name: '反馈问题', component: () => import('../views/System/FeedbackProblem.vue'), meta: { requiresAuth: true }},
//       { path: 'QuestionsList', name: '问题列表', component: () => import('../views/System/QuestionsList.vue'), meta: { requiresAuth: true }},
//       { path: 'NotificationMessages', name: '通知消息', component: () => import('../views/System/NotificationMessages.vue'), meta: { requiresAuth: true }},
//     ]
//   },
//   {
//     path: '/about',
//     name: 'about',
//     component: () => import('../views/AboutView.vue')
//   },
//   {
//     path: '/login',
//     name: '登录',
//     component: () => import('../views/Login.vue')
//   },
//   {
//     path: '/register',
//     name: 'register',
//     component: () => import('../views/Register.vue')
//   }
// ]
//
// const router = new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes
// })
//
// // 全局前置守卫
// router.beforeEach((to, from, next) => {
//   if (to.meta.requiresAuth && !isLoggedIn()) {
//     next({ name: '登录' });
//   } else {
//     next();
//   }
// });
//
// export default router;